const resolveRiotBarLoaded = () => {
  return new Promise((resolve) => {
    if (window.RiotBar) {
      resolve();
    } else {
      const interval = setInterval(() => {
        if (window.RiotBar) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    }
  });
};

export const isLoggedIn = async () => {
  await resolveRiotBarLoaded();
  const authState = window.RiotBar.account.getAuthState();
  return authState && authState.isAuthenticated;
};
